import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function estoqueValidator(amountRemaining: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (amountRemaining === 0) {
      return { emptyStock: true };
    }
    return null;
  };
}
